/* eslint-disable */

export interface HistoryListResponseDto {
  id: number;
  dateSent: Date;
  emailSubject: string;
  usedProductsFilter: string[];
  usedRolesFilter: string[];
  usedSaasFilter: boolean | null;
  totalRecipients: number;
  successfulRecipients: number;
  failedRecipients: number;
  pendingRecipients: number;
}

export const fixHistoryListResponseDtoFromJson = (dto?: HistoryListResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.dateSent = dto.dateSent && new Date(dto.dateSent);
};

export const fixHistoryListResponseDtoToJson = (dto?: HistoryListResponseDto | null): void => {
  if (!dto) {
    return;
  }
};
